import { render, staticRenderFns } from "./DishSales.vue?vue&type=template&id=e66b24ca&scoped=true"
import script from "./DishSales.vue?vue&type=script&lang=js"
export * from "./DishSales.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e66b24ca",
  null
  
)

export default component.exports